import SettingsData from "./SettingsData";
import moment from 'moment';
import Service from "./Service";

const defaultWeekHours = [false, [9, 18], [9, 18], [9, 18], [9, 18], [9, '15:30'], false];
const service = new Service();



export class SettingsHours{
    constructor(dataPath){
        this.cache = new SettingsData(dataPath, 'hours');
    }

    set defaultWeekHours(val){
        this.cache.setData('default', val);
    }

    get defaultWeekHours(){
        let dwh = this.cache.getData('default');
        if(dwh == null){
            this.defaultWeekHours = defaultWeekHours;
            dwh = this.cache.getData('default');
        }
        //let def = this.cache.getData('default');
        return dwh;
    }

    getWeekHours(date){
        let timeData = [];
        let curDate = moment(date);
        for(let i=0; i < 7; i++){
            let dayDate = curDate.day(i);
            timeData.push( this.getDateHours(dayDate) );
        }
        return timeData;
    }

    setDateHoursException(date, hours){
        let dt = moment(date);
        let cacheId = dt.format('YYYY/M/D');
        this.cache.setData('exceptions/' + cacheId, hours);
    }
    
    getDateHoursException(date){
        let dt = moment(date);
        let cacheId = dt.format('YYYY/M/D');
        return this.cache.getData('exceptions/' + cacheId);
    }

    deleteDateHoursException(date){
        let dt = moment(date);
        let cacheId = dt.format('YYYY/M/D');
        this.cache.removeData('exceptions/' + cacheId);
        this.cache.removeData('exceptions/' + cacheId + '/server');
    }

    getDateHours(date){
        let dt = moment(date);
        let exception = this.getDateHoursException(date);
        if(exception != null)return exception;
        return this.defaultWeekHours[dt.day()];
    }

    isSameHours(h1, h2){
        if(h1 instanceof Array && h2 instanceof Array){
            if(h1.length === h2.length){
                for(let i=0; i < h1.length; i++){
                    if(h1[i] != h2[i])return false;
                }
                return true;
            }
        }

        if(h1 === h2)return true;

        return false;
    }


    //Converts Server String Named data to Array
    defaultServerToCache(serverData){
        let cacheData = [];
        for(let i=0; i < 7; i++){
            let dayName = moment().day(i).format('dddd').toLowerCase();
            let startName = dayName + 'Start';
            let endName = dayName + 'End';
            let startValue = serverData[startName];
            let endValue = serverData[endName];
            if(startValue === 'off' || startValue === undefined){
                cacheData.push(false);
            }else{
                cacheData.push([moment(startValue, 'h:mm a').format('H:mm'), moment(endValue, 'h:mm a').format('H:mm')])
            }
        }

        return cacheData;
    }

    //Converts array times to server string data
    defaultCacheToServer(cacheData){
        let serverData = {};
        for(let i=0 ; i < cacheData.length; i++){
            let data = cacheData[i];
            let dayName = moment().day(i).format('dddd').toLowerCase();
            let startName = dayName + 'Start';
            let endName = dayName + 'End';
            if(data === false){
                serverData[startName] = 'off';
                serverData[endName] = 'off';
            }else{
                serverData[startName] = moment(data[0], 'H:mm').format('h:mm a');
                serverData[endName] = moment(data[1], 'H:mm').format('h:mm a');   
            }
        }
        return serverData;
    }

    serverDefaults(api, options){

     
        return service.request(api, options).then((json) => {
            if(json && json.userAvailabilityId){
                this.cache.setData('default/server', json);
                this.defaultWeekHours = this.defaultServerToCache(json);
            }         

            return this.defaultWeekHours;
        }).catch(()=>{
            this.defaultWeekHours = defaultWeekHours;
            return Promise.resolve(defaultWeekHours);
        })
    }
    getServerDefaultsJSON(){
        return this.cache.getData('default/server') || this.defaultCacheToServer(this.defaultWeekHours);
    }
    setServerDefaultsJSON(data){
        return this.cache.setData('default/server', data);
    }

    serverExceptions(api, options){
        return service.request(api, options).then((result) => {
            let json = (result instanceof Array)? result: [result];
            for(let i=0 ; i< json.length; i++){
                let ex = json[i];
                if(ex.id == null)continue;
                //if(ex.message == 'Invalid date')continue;
                let data = this.exceptionServerToCache(ex);
                //if(data == false)continue;
                this.setDateHoursException(ex.date, data);
                let dt = moment(ex.date);
                let cacheId = dt.format('YYYY/M/D');
                this.cache.setData('exceptions/' + cacheId + '/server', ex);
            }
            return json;
        })
    }

    getServerExceptionJSON(date){
        let cacheId = moment(date).format('YYYY/M/D');
        return this.cache.getData('exceptions/' + cacheId + '/server');
    }

    exceptionServerToCache(serverData){
        if(serverData.startTime == 'off')return false;
        let startTime = moment(serverData.startTime, 'h:mm a').format('H:mm');
        let endTime = moment(serverData.endTime, 'h:mm a').format('H:mm');

        if(startTime == 'Invalid date' || endTime == 'Invalid date')return false;

        return [startTime, endTime]
    }

    exceptionCacheToserver(cacheData, date){
        
        return {
            date: moment(date).format('YYYY-MM-DD'),
            startTime: (cacheData === false)? 'off':moment(cacheData[0], 'H:mm').format('h:mm a'),
            endTime: (cacheData === false)? 'off':moment(cacheData[1], 'H:mm').format('h:mm a')
        };

    }


}


// WEBPACK FOOTER //
// ./src/api/SettingsHours.js